import { render, staticRenderFns } from "./HearosNew.vue?vue&type=template&id=32a261b3&"
import script from "./HearosNew.vue?vue&type=script&lang=js&"
export * from "./HearosNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports